import {BaseApi} from '@/api/base-api';
import {API_POLL_INTERVAL} from '@/constants';

enum TaskStatus {
  SUCCESS = 'SUCCESS',
  PENDING = 'PENDING',
  FAILURE = 'FAILURE',
}

const AUTH_TOKEN = 'token';
const HOME_TYPE = 'type';
const HOME_SORT_BY = 'sortBy';
const HAS_REGISTERED = 'hasRegistered';


export const WHAT_IS_THIS = 'whatisthis';
export const LPO_WHAT_IS_THIS = 'lpowhatisthis';

export const GA_BANNER_HIDDEN = 'gaBannerHidden';

export function getTokenFromCookies() {
  if (typeof window !== 'undefined') {
    const eleId = document.getElementById('customerToken') as any;
    return eleId?.value || localStorage.getItem(AUTH_TOKEN) || '';
  }
}


export function setTokenIntoCookies(token: string) {
  localStorage.setItem(AUTH_TOKEN, token);
}

export function flushTokenFromCookies() {
  localStorage.removeItem(AUTH_TOKEN);
}

export function setHasRegisteredIntoStorage() {
  localStorage.setItem(HAS_REGISTERED, 'YES');
}

export function getHasRegisteredFromStorage() {
  return localStorage.getItem(HAS_REGISTERED) || '';
}

export function clearHomeSortFromStorage() {
  localStorage.removeItem(HOME_SORT_BY);
  localStorage.removeItem(HOME_TYPE);
}

export function getAuthHeader(headers = {}) {
  if (getTokenFromCookies()) {
    headers['Authorization'] = getAuthorizationHeader();
  }
  return headers;
}

export function getAuthorizationHeader() {
  return `Bearer ${getTokenFromCookies()}`;
}

export function getHeaders() {
  return {
    headers: {Authorization: getAuthorizationHeader()},
  };
}

export function getApiHost(service: string) {
  if (service === BaseApi.LINKGRAPH_ENDPOINT) {
    return process.env.LG_HOST || '';
  } else {
    return null;
  }
}

export function getApiUrl(service: string, url: string) {
  return `${getApiHost(service)}${url}`;
}

export async function retry<T>(callback: () => Promise<T>, status: Array<keyof T>): Promise<T> {
  return callback()
    .then(async resp => {
      const didFinish = status.every(status => {
        const respStatus: TaskStatus = resp[status] as unknown as TaskStatus;
        return respStatus === TaskStatus.SUCCESS || respStatus === TaskStatus.FAILURE;
      });
      const isPending = status.some(
        status =>
          ((resp[status] as unknown) as TaskStatus) !== TaskStatus.SUCCESS &&
          ((resp[status] as unknown) as TaskStatus) !== TaskStatus.FAILURE,
      );
      if (didFinish) {
        return resp;
      }
      if (isPending) {
        await new Promise(r => setTimeout(r, API_POLL_INTERVAL));
        return retry<T>(callback, status);
      }
      return resp;
    })
    .catch(e => {
      throw new Error(e);
    });
}

export const getMessagesFromErrorResponse = (errorResponse: any, plainString = false): string[] | string => {
  const messages: string[] = [];
  let messageStr = '';
  const responseData = errorResponse.response.data;
  Object?.keys(responseData).forEach( (key: string) => {
    if (typeof(responseData[key]) == 'string') {
      messageStr += `${responseData[key]}`;
      messages.push(responseData[key]);
    } else {
      messageStr += `${responseData[key][0]}.`;
      messages.push(responseData[key][0]);
    }
  });
  return plainString ? messageStr : messages;
};

export function convertDom(str: string) {
  const a = str.split(/(?=[A-Z])/);
  return a.join('.').toLowerCase();
}

export const getExportUrl = (params:any, pageSize:number): string => {
  Object.keys(params).forEach(param => {
    if (params[param]=='' || typeof params[param] == 'undefined') {
      delete params[param];
    }
  });
  params['page'] = 1;
  params['page_size'] = pageSize;
  return new URLSearchParams(params)?.toString();
};
